import React from 'react';
import { Field } from 'react-final-form';
import Autocomplete from '@mui/material/Autocomplete';
import { TextField as TextFieldMaterial } from '@mui/material';
import ClearChip from '../../../../components/ClearChip';

const ReceivingAgencyField = ({ receivingAgenciesList, form }) => {
  const values = form.getState().values;

  return (
    <Field
      name="receiver"
      render={({ input }) => {
        if (values.receiver) {
          return (
            <ClearChip
              value={input.value}
              onClick={() => {
                input.onChange(null);
                form.change('receiver_id', null);
              }}
            />
          );
        }

        return (
          values.receiver_id === null && (
            <Autocomplete
              options={receivingAgenciesList}
              sx={{ minWidth: 300 }}
              getOptionLabel={res => (res ? res.name : '')}
              onChange={(event, rescuer) => {
                input.onChange(rescuer.value);
                form.change('receiver_id', rescuer.id);
              }}
              onBlur={input.onBlur}
              onFocus={input.onFocus}
              size="small"
              renderInput={params => (
                <TextFieldMaterial {...params} placeholder="Receiving Agency" variant="outlined" fullWidth />
              )}
              noOptionsText="There are no active receiving agencies in the Site"
            />
          )
        );
      }}
    />
  );
};

export default ReceivingAgencyField;
